const stringHelpers = require('../../../common/components/stringhelpers');

module.exports = function (BreakpointsService, $location, categoriesService, $templateCache, RRPubSub, $state, searchService, $rootScope, $window, CurationService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            const location = $location.path();
            if (location === '/wine' || location === '/beer' || location === '/spirits' || location === '/spirits/premixed-drinks') {
                CurationService.showCuration(location);
            }
            scope.categoryService = categoriesService;
            scope.isSmallFormat = BreakpointsService.isSmallFormat();

            function sendRRevent() {
                let leafCategory = $state.params.subcategory || $state.params.category || $state.params.subdepartment || $state.params.department || undefined;
                if (leafCategory === $state.params.department) {

                    searchService.searchByCategory({ Department: leafCategory, PageNumber: 1, PageSize: 0, Location: $window.location.pathname }).then(function (response) {

                        leafCategory = stringHelpers.toTitleCase(leafCategory.replace(new RegExp('-', 'g'), ' '));
                        RRPubSub.publish(RRPubSub.EVENTS.DEPARTMENT_PAGE, {
                            id: response.categoryId,
                            name: leafCategory
                        });

                    });
                }
            }

            scope.isDepartmentPage = function () {
                return !$state.params.subcategory && !$state.params.category && !$state.params.subdepartment && $state.params.department;
            };

            $rootScope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.isSmallFormat = BreakpointsService.isSmallFormat();
                });
            });

            scope.$watch('categoryService.categories', (category) => {
                setTimeout(() => sendRRevent());
                if (category && category.length !== 0) {
                    $templateCache.put('template-category.html', `<div>${category[0].Attributes.category_description}</div>`);
                }
            });

            scope.$on('$destroy', function () {
              categoriesService.categories = [];
            });

        },
        template: require('./categories-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/categories/categories-directive.js
 **/